// extracted by mini-css-extract-plugin
export default {"header":"style_header__1X6o9","header_title":"style_header_title__qWV-i"};